export const THEMES_CSS = `
  :host {
    --qgh-radius: 0px;
    --qgh-bg:         #0d1f17;
    --qgh-color:      #dceee4;
    --qgh-accent:     #4cdb84;
    --qgh-label-bg:   #1a9e55;
    --qgh-border:     rgba(255,255,255,.07);
    --qgh-nav-bg:     rgba(255,255,255,.08);
    --qgh-nav-hover:  rgba(255,255,255,.16);
    --qgh-fb-bg:      rgba(255,255,255,.10);
    --qgh-pow-color:  #dceee4;
    --qgh-logo-filter: none;
  }
  :host([theme="light"]) {
    --qgh-bg:         #ffffff;
    --qgh-color:      #1a1a1a;
    --qgh-accent:     #1a9e55;
    --qgh-label-bg:   #1a9e55;
    --qgh-border:     rgba(0,0,0,.08);
    --qgh-nav-bg:     rgba(0,0,0,.06);
    --qgh-nav-hover:  rgba(0,0,0,.12);
    --qgh-fb-bg:      rgba(0,0,0,.08);
    --qgh-pow-color:  #555555;
    --qgh-logo-filter: brightness(0);
  }
  :host([theme="ocean"]) {
    --qgh-bg:         #0a1628;
    --qgh-color:      #c8d8f0;
    --qgh-accent:     #4a9eff;
    --qgh-label-bg:   #1a4a8a;
    --qgh-border:     rgba(255,255,255,.07);
    --qgh-nav-bg:     rgba(255,255,255,.08);
    --qgh-nav-hover:  rgba(255,255,255,.16);
    --qgh-fb-bg:      rgba(255,255,255,.10);
    --qgh-pow-color:  #c8d8f0;
    --qgh-logo-filter: none;
  }
  :host([theme="midnight"]) {
    --qgh-bg:         #0a0a0a;
    --qgh-color:      #e0e0e0;
    --qgh-accent:     #f0c040;
    --qgh-label-bg:   #222222;
    --qgh-border:     rgba(255,255,255,.06);
    --qgh-nav-bg:     rgba(255,255,255,.06);
    --qgh-nav-hover:  rgba(255,255,255,.12);
    --qgh-fb-bg:      rgba(255,255,255,.08);
    --qgh-pow-color:  #aaaaaa;
    --qgh-logo-filter: none;
  }
  :host([theme="clasico"]) {
    --qgh-bg:         #111111;
    --qgh-color:      #ffffff;
    --qgh-accent:     #ffffff;
    --qgh-label-bg:   #111111;
    --qgh-border:     rgba(255,255,255,.12);
    --qgh-nav-bg:     rgba(255,255,255,.10);
    --qgh-nav-hover:  rgba(255,255,255,.20);
    --qgh-fb-bg:      rgba(255,255,255,.10);
    --qgh-pow-color:  #aaaaaa;
    --qgh-logo-filter: none;
  }
  :host([theme="rojo"]) {
    --qgh-bg:         #1a0505;
    --qgh-color:      #f5dada;
    --qgh-accent:     #ff4444;
    --qgh-label-bg:   #cc0000;
    --qgh-border:     rgba(255,255,255,.07);
    --qgh-nav-bg:     rgba(255,255,255,.08);
    --qgh-nav-hover:  rgba(255,255,255,.16);
    --qgh-fb-bg:      rgba(255,255,255,.10);
    --qgh-pow-color:  #f5dada;
    --qgh-logo-filter: none;
  }
  :host([round="large"]) { --qgh-radius: 10px; }
`;

export const SHARED_CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap');
  .dot {
    width: 6px; height: 6px; border-radius: 50%;
    background: var(--qgh-accent); flex-shrink: 0;
    animation: blink 1.2s ease-in-out infinite;
  }
  @keyframes blink { 0%,100%{opacity:1} 50%{opacity:.25} }
  .powered {
    display: flex; align-items: center; justify-content: center;
    padding: 5px 10px;
    border-top: 1px solid var(--qgh-border);
  }
  .powered a {
    display: flex; align-items: center; gap: 6px;
    text-decoration: none; opacity: .55; transition: opacity .15s;
  }
  .powered a:hover { opacity: 1; }
  .powered span { color: var(--qgh-pow-color); font-size: 9px; letter-spacing: .06em; text-transform: uppercase; }
  .powered img { height: 14px; width: auto; filter: var(--qgh-logo-filter); }
`;
